import React from "react";
import { cn } from "./cn";

export interface StatItem {
  label: string;
  value: React.ReactNode;
  hint?: React.ReactNode;
  tone?: "default" | "success" | "warning" | "danger";
}

const VALUE_TONES: Record<NonNullable<StatItem["tone"]>, string> = {
  default: "text-fg",
  success: "text-success",
  warning: "text-warning",
  danger: "text-danger",
};

const COLUMNS = {
  3: "grid-cols-3",
  4: "grid-cols-2 lg:grid-cols-4",
};

export const StatGrid: React.FC<{ items: StatItem[]; columns?: 3 | 4 }> = ({ items, columns = 4 }) => (
  <dl className={cn("grid gap-3", COLUMNS[columns])}>
    {items.map((item) => (
      <div key={item.label} className="rounded-card border border-line bg-surface p-4 shadow-card">
        <dt className="text-caption text-fg-muted">{item.label}</dt>
        <dd className={cn("mt-1 break-words text-heading font-semibold", VALUE_TONES[item.tone ?? "default"])}>
          {item.value}
        </dd>
        {item.hint && <dd className="mt-0.5 text-caption text-fg-subtle">{item.hint}</dd>}
      </div>
    ))}
  </dl>
);
